import { useForm, type FieldValues, type UseFormProps, type UseFormReturn } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import type { z } from 'zod'

/**
 * Tek tip form durumu (020). `useForm` + `zodResolver` + sabit mod: `onSubmit` (ilk gönderime kadar
 * sessiz) + `reValidateMode: onChange` (gönderim sonrası ilgili alan anında yeniden doğrulanır) —
 * spec FR-002 "gönder-sonra-anlık". Form değer tipi `z.input` (alanların tuttuğu ham değer),
 * `onValid`'e geçen tip `z.output` (parse sonrası) — kurallar tip-değiştiren transform içermediğinden
 * ikisi eşittir. RHF resolver v5 imzası bu ikiliyi ister; `any` kullanılmaz (no-any, FR-007).
 */
export function useZodForm<TSchema extends z.ZodType<FieldValues, FieldValues>>(
  schema: TSchema,
  options?: Omit<
    UseFormProps<z.input<TSchema>, unknown, z.output<TSchema>>,
    'resolver' | 'mode' | 'reValidateMode'
  >,
): UseFormReturn<z.input<TSchema>, unknown, z.output<TSchema>> {
  return useForm<z.input<TSchema>, unknown, z.output<TSchema>>({
    ...options,
    resolver: zodResolver(schema),
    mode: 'onSubmit',
    reValidateMode: 'onChange',
  })
}
